<template>
  <div class="coq-modal">
    <div class="coq-modal__top-right">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3>Gérer l'inscription à cette conférence</h3>
    <p>
      Veuillez sélectionner les membres à inscrire à cette conférence. Ceux-ci
      seront ajouté à la commande. Pour accéder à la commande pour compléter
      l'inscription, veuillez cliquer sur le bouton gris en bas de la fenêtre.
    </p>

    <br/>
    <h4>Membres non inscrits</h4>
    <table style="width: 100%">
      <tr
          v-for="member in members"
          class="class__registration__member"
          :key="member.id"
      >
        <template v-if="!memberAlreadyRegistered(member.id)">
          <td>
            <input
                type="checkbox"
                @change="registerMember($event, member.id)"
                :checked="memberAlreadyInOrder(member.id)"
            />
          </td>
          <td style="width: 90%">
            {{ member.firstName }} {{ member.lastName }}
          </td>
        </template>
      </tr>
    </table>

    <br/>
    <h4>Membres déjà inscrits</h4>
    <table style="width: 100%">
      <tr
          v-for="member in members"
          class="class__registration__member"
          :key="member.id"
      >
        <template v-if="memberAlreadyRegistered(member.id)">
          <td>
            <input type="checkbox" disabled readonly checked/>
          </td>
          <td style="width: 90%">
            {{ member.firstName }} {{ member.lastName }}
          </td>
        </template>
      </tr>
    </table>

    <div class="coq-modal__footer">
      <a
          class="btn btn-secondary"
          style="margin-right: 10px; width: 85%"
          @click="$emit('close') && $router.push({ name: 'CartPage' })"
      >
        Aller au panier
      </a>
      <a class="btn btn-primary" @click="$emit('close')">
        Fermer
      </a>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'conference-registration-modal',
    props: {
      conferenceId: {
        type: String
      }
    },
    data() {
      return {
        registrations: {}
      };
    },
    async beforeMount() {
      await this.getCart();
    },
    async mounted() {
      await this.fetchMembers();
    },
    computed: {
      ...mapGetters('services', {
        _getConference: 'conference'
      }),
      ...mapGetters('orders', {
        cart: 'cart'
      }),
      conference() {
        return this._getConference(this.conferenceId);
      },
      members() {
        return this.$store.getters['members/getMembers'];
      }
    },
    methods: {
      ...mapActions('orders', {
        getCart: 'getCart',
        upsertRegistration: 'upsertRegistration',
        deleteRegistration: 'removeRegistration'
      }),
      ...mapActions('members', {
        fetchMembers: 'fetchMembers'
      }),

      /**
       * Add or update the conference in the cart.
       */
      async registerMember(event, memberId) {
        if (event.target.checked === true) {
          this.upsertRegistration({
            registrationId: this.conferenceId,
            type: 'conference',
            memberId
          });
        }
        else if (event.target.checked === false) {
          this.deleteRegistration({
            registrationId: this.conferenceId,
            type: 'conference',
            memberId
          });
        }
      },
      memberAlreadyRegistered(memberId) {
        for (const r of this.conference.registrations) {
          if (r.member && r.member.id === memberId) {
            return true;
          }
        }
        return false;
      },
      memberAlreadyInOrder(memberId) {
        for (const r of this.cart.registrations) {
          if (
            r !== null &&
            r.member &&
            r.member.id === memberId &&
            r.conference &&
            r.conference.id === this.conferenceId
          ) {
            return true;
          }
        }
        return false;
      }
    }
  };
</script>

<style scoped></style>
